import {
  CHANGE_ROW_SELECTION,
  RESET_ROWS_SELECTION,
  UPDATE_SORTING,
  INIT_TABLE,
  TOGGLE_EXPANDABLE_ROW,
} from './constants';

export function changeRowSelection(path, config, data) {
  return {
    path,
    config,
    data,
    type: CHANGE_ROW_SELECTION,
  };
}

export function resetRowsSelection(path, config, isSelected) {
  return {
    path,
    config,
    data: isSelected,
    type: RESET_ROWS_SELECTION,
  };
}

export function updateSorting(path, config, sortingInfo) {
  return {
    path,
    config,
    data: sortingInfo,
    type: UPDATE_SORTING,
  };
}

export function initTable(path, config) {
  return {
    path,
    config,
    type: INIT_TABLE,
  };
}

export function toggleExpandableRow(path, config, data) {
  return {
    path,
    config,
    data,
    type: TOGGLE_EXPANDABLE_ROW,
  };
}
